import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../shared-components/ng-login/auth/auth.service';
import { Injectable } from '@angular/core';
import { Roles } from '../utils/enums';

@Injectable()
export class SupportGuard implements CanActivate {
  /**
   * Constructor
   * @param router
   * @param authService
   */
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean {
    const userRoles = this.authService.getUserData().roles;
    if (!userRoles.includes(Roles.SUPPORT) && !userRoles.includes(Roles.ADMIN)) {
      this.router.navigate(['dashboard']);

      return false;
    }

    return true;
  }
}
